export enum ProductIdentificationMode {
    BarcodeRead,
    ManualSKUCheck,
}
